'use client';

import {clsx} from '@gfiber/typesmith';
import type {ReactNode} from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import styles from './Screentip.module.scss';

export enum TooltipSide {
  TOP = 'top',
  Right = 'right',
  BOTTOM = 'bottom',
  LEFT = 'left',
}

export enum TooltipAlign {
  START = 'start',
  END = 'end',
  CENTER = 'center',
}

type TooltipProps = TooltipPrimitive.TooltipProps & {
  children: ReactNode;
  className?: string;
  content: ReactNode;
  arrowWidth?: number | string;
  arrowHeight?: number | string;
  side?: TooltipSide;
  align?: TooltipAlign;
  alignOffset?: number;
};

export function Screentip({
  children,
  className,
  content,
  open,
  defaultOpen,
  onOpenChange,
  arrowWidth,
  arrowHeight,
  side,
  align,
  alignOffset,
  ...props
}: TooltipProps) {
  return (
    <div className={styles.wrapper}>
      <TooltipPrimitive.Provider>
        <TooltipPrimitive.Root
          open={open}
          defaultOpen={defaultOpen}
          onOpenChange={onOpenChange}
        >
          <TooltipPrimitive.Trigger asChild>
            {children}
          </TooltipPrimitive.Trigger>
          <TooltipPrimitive.Content
            side={side}
            align={align}
            alignOffset={alignOffset}
            {...props}
            className={clsx(styles.menuContent, className)}
          >
            {content}
            <TooltipPrimitive.Arrow
              width={arrowWidth || 0}
              height={arrowHeight || 0}
              className={styles.Arrow}
            />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Root>
      </TooltipPrimitive.Provider>
    </div>
  );
}
